import dayjs from 'dayjs';
import { CalendarShift } from '@composite/calendar/types';
import { getIntervals } from '@composite/calendar/utils/get-template';
import { WorkOrder } from '@models';
import { WorkOrderDto } from '../utils/prepare-dto';

const getLastWorkIntervalOfShift = (shift?: CalendarShift) => {
  if (!shift) {
    return undefined;
  }
  const todayIntervals = getIntervals(shift);
  const workShifts = todayIntervals.filter(
    (interval) => interval.type !== 'V' && interval.type !== 'O'
  );
  const lastShift =
    workShifts.length > 0 ? workShifts[workShifts.length - 1] : undefined;

  return lastShift;
};

const getIsMultiday = ({
  workOrder,
  calendarStartDate,
  shifts,
}: {
  workOrder: WorkOrderDto;
  calendarStartDate: string;
  shifts: (CalendarShift | undefined)[];
}): boolean => {
  const MULTIDAY_NUM_HOURS_TOLERANCE = 1;

  // dayjs date where should new WO end
  const plannedTo = dayjs.tz(workOrder.plannedTo);
  const plannedFrom = dayjs.tz(workOrder.plannedFrom);

  // if planned to is different day then plannedTo, it is definitely multiday
  if (!plannedFrom.isSame(plannedTo, 'day')) {
    return true;
  }

  // index of the shift where the new WO should end based on duration only
  const targetShiftIndex = dayjs(plannedTo.startOf('day')).diff(
    calendarStartDate,
    'day'
  );

  // the last valid shift interval (ending hour) of the day where the new WO should end based on duration only
  const lastValidShiftInterval = getLastWorkIntervalOfShift(
    shifts?.[targetShiftIndex]
  )?.endingHour;

  // datetime (dayjs) with tolerance added - if the new WO ends after this time it is MULTIDAY WO
  const maxValidHourOfTheDay = dayjs(
    `${plannedTo.startOf('day').format('YYYY-MM-DD')}T${lastValidShiftInterval}`
  ).add(MULTIDAY_NUM_HOURS_TOLERANCE, 'hour');

  return maxValidHourOfTheDay.isBefore(plannedTo);
};

const workOrdersMultipleStates = (workOrders: WorkOrder[]) => {
  return (
    workOrders.some((w) => w.currentState?.code === 'POZ') &&
    workOrders.some((w) => w.currentState?.code === 'NOV')
  );
};

export const dragEndUtils = {
  getIsMultiday,
  workOrdersMultipleStates,
};
